import { DataList, DataListGroupProps } from '@components/patterns/DataList';

export type PrettyJSONGroupProps = Pick<
  DataListGroupProps,
  'children' | 'label' | 'defaultOpen' | 'expandable' | 'value' | 'variant'
>;

export function PrettyJSONGroup({
  children,
  label,
  defaultOpen,
  expandable,
  value,
  variant,
}: PrettyJSONGroupProps) {
  return (
    <DataList.Group
      label={label}
      defaultOpen={defaultOpen}
      expandable={expandable}
      value={value}
      variant={variant}
    >
      {children}
    </DataList.Group>
  );
}
